import { lazy } from 'react'
import { Route } from 'commons/types/route'
import { FORBIDDEN_ROUTE } from 'commons/constants/app'
import homeRoutes from './home'
import authRoutes from './auth'
import participationRoutes from './participation'
import managerApprovalRoutes from './managerApproval'
import rulesRoutes from './rules'
import reportRoute from './DownloadReport'
import guestsRoutes from './guests'
import contentManagementRoutes from './contentManagement'
import sharingManegementRoutes from './sharingManegement'
import participationConfirmationRoutes from './participationConfirmation'

const NotFoundPage = lazy(() => import('pages/Common/NotFound'))
const ForbiddenPage = lazy(() => import('pages/Common/Forbidden'))

const routes: Route[] = [
  ...homeRoutes,
  ...authRoutes,
  ...participationRoutes,
  ...managerApprovalRoutes,
  ...rulesRoutes,
  ...guestsRoutes,
  ...reportRoute,
  ...contentManagementRoutes,
  ...sharingManegementRoutes,
  ...participationConfirmationRoutes,
  {
    path: FORBIDDEN_ROUTE,
    isPublic: true,
    hasLayout: false,
    component: ForbiddenPage,
  },
  {
    path: '*',
    isPublic: true,
    hasLayout: false,
    component: NotFoundPage,
  },
]

export default routes
